<template>
  <div class="content-area ajustaElColorDeFondo">
    <h1>Hubo un error en el sistema</h1>
    <br />
    <h2 v-if="mensaje != null">
      <strong>Mensaje</strong>
      <br />
      {{mensaje}}
    </h2>
  </div>
</template>

<script>
  export default {
    data: {
      mensaje: null
    }
  }
</script>

<style scoped>
  .ajustaElColorDeFondo {
    background-color: #1f1f21 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Comunes/Error500.vue